import { Fragment, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import HoverToolTip from "../HoverToolTip";


export default function MapButtonField({ label, definition, layoutObject, updateFunc, screenSize, extraClass, saveFunc }: AttributeFieldProps & { extraClass?: string }) {


    let val = GetComponentOrStyleValueFromDefinition(definition, layoutObject, screenSize);
    let inx = 0; // set default to the left most button incase we can't find its value
    for (let i = 0; i < definition.options.length; i++) {
        if (definition.options[i].value == val) {
            inx = i;
            break;
        }
    }

    const [currentSlection, setSelection] = useState(inx);
    const updateAttribute = (newValue: string) => {
        updateFunc(definition.attKey, newValue, definition.targetType);
        let index = (newValue.length <= 0) ? 0 : definition.options.length;

        for (let i = 0; i < definition.options.length; i++) {
            if (definition.options[i].value == newValue) {
                index = i;
                break;
            }
        }
        setSelection(index);
    }
    return (
        <div className={"wb-input-group " + (extraClass ?? "") + " " + definition.attKey.toLowerCase()}>
            {definition.label &&
                <label className={(val == "") ? "not-updated" : "updated"}>{label}</label>
            }
            <div className="wb-input-row">
                {definition.options.map((option, index) => {
                    let className = index == currentSlection ? "selected" : "";

                    return (
                        <Fragment key={index}>

                            <button
                                className={className}
                                key={index}
                                style={(option.label == "Auto" || (option.label as string).length > 2) ? { fontSize: "13px" } : {}}
                                onClick={() => {
                                    updateAttribute(option.value);
                                    //save update for special cases
                                    if (definition.attKey == "isLink") {
                                        saveFunc();
                                    }
                                }}
                            >
                                <span>
                                    {option.value == "1" &&
                                        <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.57812 0.28125C2.95898 0.28125 3.28125 0.603516 3.28125 0.984375V2.39062C3.28125 2.80078 2.95898 3.09375 2.57812 3.09375H1.17188C0.761719 3.09375 0.46875 2.80078 0.46875 2.39062V0.984375C0.46875 0.603516 0.761719 0.28125 1.17188 0.28125H2.57812ZM14.0625 0.75C14.5605 0.75 15 1.18945 15 1.6875C15 2.21484 14.5605 2.625 14.0625 2.625H5.625C5.09766 2.625 4.6875 2.21484 4.6875 1.6875C4.6875 1.18945 5.09766 0.75 5.625 0.75H14.0625ZM14.0625 5.4375C14.5605 5.4375 15 5.87695 15 6.375C15 6.90234 14.5605 7.3125 14.0625 7.3125H5.625C5.09766 7.3125 4.6875 6.90234 4.6875 6.375C4.6875 5.87695 5.09766 5.4375 5.625 5.4375H14.0625ZM14.0625 10.125C14.5605 10.125 15 10.5645 15 11.0625C15 11.5898 14.5605 12 14.0625 12H5.625C5.09766 12 4.6875 11.5898 4.6875 11.0625C4.6875 10.5645 5.09766 10.125 5.625 10.125H14.0625ZM0.46875 5.67188C0.46875 5.29102 0.761719 4.96875 1.17188 4.96875H2.57812C2.95898 4.96875 3.28125 5.29102 3.28125 5.67188V7.07812C3.28125 7.48828 2.95898 7.78125 2.57812 7.78125H1.17188C0.761719 7.78125 0.46875 7.48828 0.46875 7.07812V5.67188ZM2.57812 9.65625C2.95898 9.65625 3.28125 9.97852 3.28125 10.3594V11.7656C3.28125 12.1758 2.95898 12.4688 2.57812 12.4688H1.17188C0.761719 12.4688 0.46875 12.1758 0.46875 11.7656V10.3594C0.46875 9.97852 0.761719 9.65625 1.17188 9.65625H2.57812Z" fill="#333333" />
                                        </svg>

                                    }
                                    {option.value == "2" &&
                                        <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.5625 3.33203C0.5625 2.98047 0.826172 2.59961 1.14844 2.45312L5.25 0.8125V12.0625L1.17773 13.9082C0.884766 14.0547 0.5625 13.8203 0.5625 13.4688V3.33203ZM6.1875 12.0625V0.8125L11.8125 2.6875V13.9375L6.1875 12.0625ZM16.793 0.871094C17.0859 0.724609 17.4375 0.958984 17.4375 1.31055V11.4473C17.4375 11.7988 17.1445 12.1797 16.8223 12.3262L12.75 13.9375V2.6875L16.793 0.871094Z" fill="#333333" />
                                        </svg>

                                    }
                                </span>
                                {option.label}
                                {option.toolTip && <HoverToolTip text={option.toolTip} checkScroll={true} />}
                            </button>
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
}